// Qual chave de tradução usar para o erro que o backend mandou.
//
// Quase todo código vem inteiro ("ERR_NO_PERMISSION"). Alguns carregam um
// detalhe depois de ":" — o horário de atendimento manda qual dia ou qual data
// falhou, e isso é o que serve no log. O corte, porém, não pode ser cego:
// mensagens legíveis também têm dois-pontos ("ERR_WAHA: sessão parada"), e
// cortar ali apagava a metade que explicava o problema.
//
// A regra: o código inteiro manda; só se ELE não tiver tradução é que se tenta
// o prefixo; e o prefixo só vale se tiver tradução. Sem nenhuma das duas, o
// texto sai como veio.
//
// Fica separado do `toastError` porque é a única parte com regra de verdade —
// e assim dá para conferir sem navegador (`chaveDeErro.check.mjs`).
export const chaveDeErro = (bruto, existe) => {
	const texto = String(bruto || "").trim();

	if (!texto) return null;

	if (existe(texto)) return texto;

	const prefixo = texto.split(":")[0].trim();

	if (prefixo !== texto && existe(prefixo)) return prefixo;

	return null;
};

export default chaveDeErro;
